import * as Request from '../Request';

const User = {
  // 员工修改自己的登录密码
  changePassword: (data) => {
    return Request.put('/sys/user/changePwd', data);
  },
  // 根据登录的账号，获取菜单树
  getMyMenu: (data) => {
    return Request.get('/sys/menu/privilege', data);
  },
  // 登录
  login: (data) => {
    return Request.postQuery('/login', data);
  },
  getUserInfo: () => {
    return Request.get('/sys/user/getInfoByToken');
  }
}
export default User
